import { getDecodedEvent, readContract, writeContractAndWait } from "../viem";
import config from "../../config/config";
import { parseNewCrimeEvent } from "../game";

import MafiaBasicCrimeAbi from "../../abis/MafiaBasicCrime.json";

export interface MakeCrimeResult {
  transactionHash: string;
  blockNumber: number;
  criminal: string;
  crimeType: number;
  isSuccess: boolean;
  isJailed: boolean;
  cashAmount: number;
  xpPoint: number;
  nextCrimeTime: number;
  timestamp: number;
}

export const makeCrime = async (
  crimeType: number,
  account: string
): Promise<MakeCrimeResult> => {
  try {
    const tx = await writeContractAndWait({
      address: config.basicCrimeAddress,
      abi: MafiaBasicCrimeAbi,
      functionName: "makeCrime",
      args: [crimeType],
      account,
      useMaxGas: true,
    });

    let parsed = {
      criminal: account,
      crimeType: 0,
      isSuccess: false,
      isJailed: false,
      cashAmount: 0,
      xpPoint: 0,
      nextCrimeTime: 0,
      timestamp: 0,
    };

    const event = getDecodedEvent(tx, MafiaBasicCrimeAbi, "NewCrime");
    if (event) {
      parsed = parseNewCrimeEvent(event);
    }

    return {
      transactionHash: tx.transactionHash,
      blockNumber: Number(tx.blockNumber),
      ...parsed,
    };
  } catch (error) {
    console.error("Error executing crime:", error);
    throw error;
  }
};

export const getSuccessRate = async (rankLevel: number, crimeType: number) => {
  return readContract({
    address: config.basicCrimeAddress,
    abi: MafiaBasicCrimeAbi,
    functionName: "getSuccessRate",
    args: [rankLevel, crimeType],
  });
};

export const getNextCrimeTime = async (account: string) => {
  const nextCrimeTime = await readContract<string>({
    address: config.basicCrimeAddress,
    abi: MafiaBasicCrimeAbi,
    functionName: "nextCrimeTime",
    args: [account],
  });
  return Number(nextCrimeTime);
};
